import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';
import * as MessageActions from '../../../common/messageBox/actions/actions';
import {getUrlParameters} from '../../../common/util/urlParameters';

export const getWtsMatriculas = (idAgenda) => apiActionCreator({
  'endpoint': `/wts/matriculas?id_agenda=${idAgenda}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_MATRICULAS,
    ActionTypes.FETCHED_WTS_MATRICULAS,
    [
      ActionTypes.FETCHED_WTS_MATRICULAS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const updateWtsMatricula = (payload) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/matriculas',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_MATRICULA,
        [
          () => {
            dispatch(getWtsMatriculas(payload.id_agenda));
            return {'type': ActionTypes.UPDATED_WTS_MATRICULA};
          },
          MessageActions.addMessageBoxInfo('Estado de matrícula actualizado exitosamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_MATRICULA_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': payload,
    })
  );
};

export const createWtsMatriculas = (payload) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/matriculas',
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_WTS_MATRICULAS,
        [
          () => {
            dispatch(getWtsMatriculas(payload.id_agenda));
            return {'type': ActionTypes.CREATED_WTS_MATRICULAS};
          },
          MessageActions.addMessageBoxInfo('Estudiantes matriculados exitosamente'),
        ],
        [
          ActionTypes.CREATED_WTS_MATRICULAS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': payload,
    })
  );
};

export const getWtsMatriculasHistory = (params) => apiActionCreator({
  'endpoint': `/wts/matriculasHistory${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_MATRICULAS_HISTORY,
    ActionTypes.FETCHED_WTS_MATRICULAS_HISTORY,
    [
      ActionTypes.FETCHED_WTS_MATRICULAS_HISTORY_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
